export const useDarkMode = defineStore('darkMode', () => {
  const darkModeCookie = useCookie('darkMode', {
    default: () => 'true',
    maxAge: 60 * 60 * 24 * 365 // 1 year
  })

  const isDarkMode = ref(false)

  // Ensure consistency between cookie, localStorage, and reactive state
  const initializeStore = () => {
    if (process.client) {
      const localDarkMode = localStorage.getItem('darkMode')
      const cookieDarkMode = darkModeCookie.value
      isDarkMode.value = localDarkMode !== null
        ? localDarkMode === 'true'
        : cookieDarkMode === 'true'
    }
  }

  // Watch and sync changes
  watch(isDarkMode, (val) => {
    if (process.client) {
      // Update localStorage
      localStorage.setItem('darkMode', val.toString())
    }

    // Update cookie
    darkModeCookie.value = val.toString()

    // Toggle the class on the <html> tag
    document.documentElement.classList.toggle('dark', val)
  })

  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value
  }

  initializeStore()

  return {
    isDarkMode,
    darkModeCookie,
    toggleDarkMode
  }
})
